<p-panel [toggleable]="true" [collapsed]="shouldBeCollapsed">
  <ng-template #header
    ><div><i class="pi pi-gauge mr-3"></i>Energy Meter Info</div></ng-template
  >
  <p-table
    showGridlines="true"
    stripedRows
    size="small"
    [loading]="isLoading()"
    [value]="energyMeterList()"
  >
    <ng-template #header>
      <tr>
        <th class="lg:w-1/10 xl:w-1/12 2xl:w-1/14 3xl:w-1/16">
          <div class="text-center">
            <span class="hidden lg:inline">Status</span>
          </div>
        </th>
        <th class="lg:w-1/7 xl:w-auto">
          <span class="hidden sm:inline">Role</span>
        </th>
        <th>Name</th>
        <th>Last Update</th>
        <th>W</th>
        <th>VAR</th>
        <th>VA</th>
        <th>Power Factor</th>
        <th>kWhe</th>
        <th>kWhi</th>
        <th>Voltage(s)</th>
        <th>Current(s)</th>
      </tr>
    </ng-template>
    <ng-template #body let-EM>
      <tr>
        <td
          [style]="
            iconsStyles.getDeviceStatusBackgroundStyle(
              customFunctions.getDeviceStatus(EM.available, EM.error)
            )
          "
        >
          <div class="text-center">
            <i
              [class]="
                iconsStyles.getDeviceStatusIcon(
                  customFunctions.getDeviceStatus(EM.available, EM.error)
                )
              "
              class="lg:mr-2"
            ></i
            ><span class="hidden lg:inline">{{
              customFunctions.getDeviceStatus(EM.available, EM.error)
            }}</span>
          </div>
        </td>
        <td>
          <i
            [class]="iconsStyles.getRoleIcon(EM.consumptionType)"
            class="lg:mr-2"
          ></i
          ><span class="hidden lg:inline">{{
            roleEnum[EM.consumptionType]
          }}</span>
        </td>
        <td>{{ EM.name }}</td>
        <td>
          <span class="hidden lg:inline">
            {{ EM.lastUpdate | date : "yyyy-MM-dd, HH:mm" }} </span
          ><span class="lg:hidden">
            {{ EM.lastUpdate | date : "MM-dd, HH:mm" }}
          </span>
        </td>
        <td>{{ EM.W }}</td>
        <td>{{ EM.VAR }}</td>
        <td>{{ EM.VA }}</td>
        <td>{{ EM.powerFactor }}</td>
        <td>{{ EM.kWhe }}</td>
        <td>{{ EM.kWhi }}</td>
        <td>[{{ EM.V1 }}, {{ EM.V2 }}, {{ EM.V3 }}]</td>
        <td>[{{ EM.I1 }}, {{ EM.I2 }}, {{ EM.I3 }}]</td>
      </tr>
    </ng-template>
  </p-table>
</p-panel>
